module.exports = __webpack_public_path__ + "img/mobile-creative-title-05.602c6841.svg";